import {
  GET_CITIES_LOADING,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { getCitiesUrl } from "api/apiUrls";

export const getCitiesAction =
  (countryId?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: GET_CITIES_LOADING, payload: true });

      const response = await listItemsService(
        `${getCitiesUrl}${countryId}`,
        ""
      );

      dispatch({ type: GET_CITIES_SUCCESS, payload: response.data });
    } catch (err) {
      dispatch({ type: GET_CITIES_FAILURE, payload: err });
    } finally {
      dispatch({ type: GET_CITIES_LOADING, payload: false });
    }
  };
